import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import {
  MAX_TILES,
  STORE_KPI_CATALOG,
  TILE_CATALOG_KEYS,
} from 'src/app/shared/constants/kpi-catalog';

@Component({
  selector: 'app-kpi-tiles-config-dialog',
  templateUrl: './kpi-tiles-config-dialog.component.html',
  styleUrls: ['./kpi-tiles-config-dialog.component.scss'],
})
export class KpiTilesConfigDialogComponent implements OnInit {
  @Input() selectedKeys: string[] = [];

  catalogKeys = TILE_CATALOG_KEYS;
  workingSelection: Set<string> = new Set();
  readonly maxTiles = MAX_TILES;

  constructor(
    private dialogRef: NbDialogRef<KpiTilesConfigDialogComponent>,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.workingSelection = new Set(this.selectedKeys.slice(0, MAX_TILES));
  }

  isSelected(key: string): boolean {
    return this.workingSelection.has(key);
  }

  toggleKey(key: string): void {
    if (this.workingSelection.has(key)) {
      this.workingSelection.delete(key);
      return;
    }
    if (this.workingSelection.size >= MAX_TILES) {
      this.toastr.warning(
        this.translate.instant('KPI.CONFIGURE_TILES.MAX_REACHED', { max: MAX_TILES })
      );
      return;
    }
    this.workingSelection.add(key);
  }

  metricLabelKey(key: string): string {
    return `KPI.NOGLETAL.${key.replace(/([A-Z])/g, '_$1').toUpperCase()}`;
  }

  metricGroupKey(key: string): string {
    const group = STORE_KPI_CATALOG[key]?.group || 'extra';
    return `KPI.OVERVIEW.GROUP_${group.toUpperCase()}`;
  }

  save(): void {
    const keys = TILE_CATALOG_KEYS.filter((key) => this.workingSelection.has(key));
    this.dialogRef.close(keys);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
